angular.module("TeamsApp").factory("TeamUserStatisticsFactory", ["$resource", function ($resource) {
    return $resource("/api/v1.0/profiles/team-stats/:team_slug/", {team_slug: '@team_slug'}, {
        query: {
            isArray: false
        }
    });
}]);